require('./bootstrap-overrides');
require('./shared/_banner');
require('./shared/_flashes');

var $document, busyloading;

window.$window = $(window);

window.$document = $(document);

$document = $(document);

window.$body = $(document.body);

// phantomjs pretends to be a touch browser
// https://github.com/ariya/phantomjs/issues/10375
window.TOUCH_DEVICE =
  'ontouchstart' in document.documentElement && !window._phantom;

if (ie) {
  $body.addClass('ie ie' + BrowserDetect.version);
}

window.showAjaxSpinner = true;

busyloading = function () {
  var $loader;
  $loader = $body.find('.loader');
  if (showAjaxSpinner && $.active !== 0) {
    $loader.addClass('active');
    $document.trigger('ajax-start');
  } else {
    $loader.removeClass('active');
    $document.trigger('ajax-stop');
  }
};

$document.ajaxStart(busyloading);

$document.ajaxStop(busyloading);

$.waitForAjax = function (fn) {
  if ($.active !== 0) {
    setTimeout(function () {
      $.waitForAjax(fn);
    }, 250);
    return;
  }
  fn();
};

// Prevent jQuery XSS vulnerability https://nvd.nist.gov/vuln/detail/CVE-2015-9251
// See https://github.com/jquery/jquery/issues/2432#issuecomment-140038536
// This can be removed when we upgrade to jQuery 3.0 or higher.
$.ajaxPrefilter(function (s) {
  if (s.crossDomain) {
    s.contents.javascript = false;
  }
});

// Prevent another jQuery XSS vulnerability
// See https://blog.jquery.com/2020/04/10/jquery-3-5-0-released/
// and https://github.com/advisories/GHSA-gxr4-xjj5-5px2
// This can be removed when we upgrade to jQuery 3.5 or higher.
jQuery.htmlPrefilter = function (html) {
  return html;
};

$(function () {
  $('a.icon.nav32-send').popover('#custom-nav-options');
  $document.on(
    'click',
    '.submit:not(select, input, .select2-container)',
    function (event) {
      var form;
      form = $(this).closest('form');
      if (form.length > 0) {
        form.submit();
        return false;
      }
    }
  );
  $document.on('change', 'select.submit, input.submit', function (event) {
    var form;
    form = $(this).closest('form');
    if (form.length > 0) {
      form.submit();
      return false;
    }
  });
  $document.on('scroll', function () {
    var top;
    top = $(window).scrollTop();
    $body.toggleClass('scrolled', top > 2500);
  });
  $body.on('click', 'a.top', function () {
    if ($body.hasClass('modal-active')) {
      $modal.animate(
        {
          scrollTop: 0,
        },
        'slow'
      );
    } else {
      $('html, body').animate(
        {
          scrollTop: 0,
        },
        'slow'
      );
    }
    return false;
  });
  window.dismissPopovers = function () {
    $('.pop').popover('hide');
  };
  $document.bind('click.popovers', function (event) {
    var $el;
    $el = $(event.target);
    if ($el.closest('div.popover').length === 0) {
      dismissPopovers();
    }
  });
  $document.bind('keyup.popovers', function (event) {
    if (event.which === 27) {
      dismissPopovers();
    }
  });
  $document.bind('keyup.modals', function (event) {
    if (event.which === 27) {
      $('.modal').modal('hide');
    }
  });
});

$document.ready(function () {
  $('#modal').on(
    'transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd',
    function () {
      var reasonText = $('.gdpr-operations-raw-data-extract-reason');
      reasonText.keyup(function () {
        if ($(this).val() !== '') {
          $('#gdpr-operations-raw-data-extract-submit').prop('disabled', false);
        } else {
          $('#gdpr-operations-raw-data-extract-submit').prop('disabled', true);
        }
      });
    }
  );
});
